import script from "./VideoeEmbed.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoeEmbed.vue?vue&type=script&setup=true&lang=ts"

import "./VideoeEmbed.vue?vue&type=style&index=0&id=a07bb174&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a07bb174"]])

export default __exports__